var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-heading"},[(_vm.suptitle)?_c('anim-text',{staticClass:"o-heading__sup | t-sub",attrs:{"tag":_vm.tagSuptitle,"text":_vm.suptitle}}):_vm._e(),(_vm.title)?_c('anim-text',{staticClass:"o-heading__title",class:_vm.classTitleFix,attrs:{"tag":_vm.tagTitle,"text":_vm.title}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }